/** @jsxImportSource @emotion/react */
import React, { useContext, useState } from 'react'
import { css, useTheme } from '@emotion/react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { ThemeUI } from '../../../theme'
import { Button, Card, Text } from '../../atoms'
import { ContentSection } from '../../organisms'
import * as styles from './index.styles'
import { Context } from "../../../context/InfoCardsContext";
import { post_info_cards } from '../../../redux/actions/info_cards/post_info_cards';
import { put_info_cards } from '../../../redux/actions/info_cards/put_info_cards';
import { delete_info_cards } from '../../../redux/actions/info_cards/delete_info_cards';
//import { get_info_cards } from '../../../redux/actions/info_cards/get_info_cards';
import Modal from '../Modal/index';


const BannerPreview: React.FC = () => {
  const dispatch = useDispatch()
  const theme = useTheme() as ThemeUI
  const navigate = useNavigate();
  const { formData } = useContext(Context)
  const token = useSelector((state: any) => state.login.access)
  let { id } = useParams();
  const [showModal, setShowModal] = useState<boolean>(false)
  const [showModalDelete, setShowModalDelete] = useState<boolean>(false)

  const handleChange = (token: any, formData: any) => {
    if (id) {
      console.log(id)
      dispatch(put_info_cards({ id, token, data: formData, navigate }))
    } else {
      delete formData.id
      dispatch(post_info_cards({ token, data: formData, navigate }))
    }
  }


  const handleDelete = () => {
    dispatch(delete_info_cards({ id, token, data: formData, navigate }))
    //dispatch(get_banners({ lang: null, token }))
  }


  const successAction = () => {
    handleChange(token, formData)
    //dispatch(get_banners({ lang: null, token }))
  }

  const closeModal = () => {
    setShowModal(false)
  }

  const closeModalDelete = () => {
    setShowModalDelete(false)
  }


  return (
    <ContentSection
      style={styles.root}
      header={
        <Text textType='p' weight='bold'>Vista Previa</Text>
      }
    >
      <div css={(theme: any) => styles.preview(theme)}>
        <Card style={css({ overflow: 'hidden' })}>
          {
            formData.image &&
            (
              <img
                src={formData.image}
                alt='placeholder'
                css={styles.previewImage}
              />
            )
          }

          <Text textType='sm' style={styles.previewTitle(theme)}>
            {formData.title}
          </Text>
          <Text textType='sm' style={styles.previewTitle(theme)}>
            {formData.description}
          </Text>
          <div css={styles.previewDescription(theme)}>
            <Text textType='sm' weight='light'>
              {formData.href}
            </Text>
            <Text textType='sm' weight='light'>
              {formData.lang}
            </Text>
          </div>
        </Card>
      </div>
      <Button onClick={() => {
        setShowModal(true)

      }} disabled={!formData.title || !formData.image || !formData.lang || !formData.href}>
        {!id ? 'Publicar' : 'Guardar'} Información
      </Button>

      {
        id ?
          (
            <Modal
              show={showModal}
              title={'¿Esta seguro de modificar esta información?'}
              text={' '}
              onClickSuccess={successAction}
              onClickClose={closeModal}
              btnSuccess={'Si'}
              btnWarning={"No"}
              onClickWarning={closeModal} />
          ) :
          (
            <Modal
              show={showModal}
              title={'¿Esta seguro de publicar esta información?'}
              text={''}
              onClickSuccess={successAction}
              onClickClose={closeModal}
              btnSuccess={'Si'}
              btnWarning={"No"}
              onClickWarning={closeModal}
            />
          )
      }


      {id && (
        <>
          <Button onClick={() => {
            setShowModalDelete(true)
          }}>
            Eliminar información
          </Button>
          <Modal
            show={showModalDelete}
            title={'¿Esta seguro de eliminar esta información?'}
            text={' '}
            onClickSuccess={handleDelete}
            onClickClose={closeModalDelete}
            btnSuccess={'Si'}
            btnWarning={"No"}
            onClickWarning={closeModalDelete}
          />
        </>
      )}
    </ContentSection>
  )
}


export default BannerPreview;
